module.exports = __webpack_public_path__ + "img/IFireShip64_ua.d074d6fd.webp";